import { render, staticRenderFns } from "./assessment-send-notice-to-repairer.vue?vue&type=template&id=98c52afa&scoped=true"
import script from "./assessment-send-notice-to-repairer.vue?vue&type=script&lang=js"
export * from "./assessment-send-notice-to-repairer.vue?vue&type=script&lang=js"
import style0 from "./assessment-send-notice-to-repairer.vue?vue&type=style&index=0&id=98c52afa&prod&scoped=true&lang=css"
import style1 from "./assessment-send-notice-to-repairer.vue?vue&type=style&index=1&id=98c52afa&prod&lang=css"
import style2 from "./assessment-send-notice-to-repairer.vue?vue&type=style&index=2&id=98c52afa&prod&lang=scss&scoped=true"
import style3 from "./assessment-send-notice-to-repairer.vue?vue&type=style&index=3&id=98c52afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c52afa",
  null
  
)

export default component.exports